// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiString from "lumi-rescript/lib/es6/src/LumiString.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Primitive_string from "@rescript/runtime/lib/es6/Primitive_string.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "./Document.res.js";

function Make(Params) {
  let documentName = Params.documentName;
  let makeDocInfo = doc => ({
    key: doc.key,
    name: documentName(Document$LumiStore.contents(doc))
  });
  let cmp = (a, b) => Primitive_string.compare(Document$LumiStore.Key.toString(a), Document$LumiStore.Key.toString(b));
  let CmpKey = Belt_Id.MakeComparable({
    cmp: cmp
  });
  let empty = Belt_Set.make(CmpKey);
  let fromArray = __x => Belt_Set.fromArray(__x, CmpKey);
  let toArray = Belt_Set.toArray;
  let has = Belt_Set.has;
  let $$Set = {
    empty: empty,
    fromArray: fromArray,
    toArray: toArray,
    has: has
  };
  let empty$1 = () => Belt_Map.make(CmpKey);
  let toArray$1 = Belt_Map.toArray;
  let fromArray$1 = __x => Belt_Map.fromArray(__x, CmpKey);
  let get = Belt_Map.get;
  let jsonCodec = valueCodec => LumiJzon.map(Document$LumiStore.Key.keyCodec, valueCodec, CmpKey);
  let $$Map = {
    empty: empty$1,
    toArray: toArray$1,
    fromArray: fromArray$1,
    get: get,
    map: Belt_Map.map,
    mapWithKey: Belt_Map.mapWithKey,
    jsonCodec: jsonCodec
  };
  let Schema$Make$DocInfo = props => {
    let __copyableKey = props.copyableKey;
    let __showKey = props.showKey;
    let href = props.href;
    let onClick = props.onClick;
    let __className = props.className;
    let match = props.docInfo;
    let key = match.key;
    let className = __className !== undefined ? __className : "is-info";
    let showKey = __showKey !== undefined ? __showKey : true;
    let copyableKey = __copyableKey !== undefined ? __copyableKey : true;
    let name = Stdlib_Option.flatMap(match.name, LumiString.nonEmpty);
    let match$1 = React.useState(() => false);
    let setKeyCopied = match$1[1];
    let keyCopied = match$1[0];
    let copyKey = event => {
      event.stopPropagation();
      let str = Document$LumiStore.Key.toString(key);
      window.navigator.clipboard.writeText(str).then(() => {
        setKeyCopied(param => true);
        return setTimeout(() => setKeyCopied(param => false), 500);
      });
    };
    return JsxRuntime.jsxs("span", {
      children: [
        JsxRuntime.jsx("a", {
          children: name !== undefined ? name : JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
              name: Params.icon
            }),
          className: LumiReact.classList([
            [
              "tag",
              true
            ],
            [
              className,
              true
            ],
            [
              "is-clickable",
              Stdlib_Option.isSome(onClick)
            ]
          ]),
          href: href,
          onClick: onClick
        }),
        JsxRuntime.jsx("a", {
          children: JsxRuntime.jsx("span", {
            children: Document$LumiStore.Key.toString(key)
          }),
          className: LumiReact.classList([
            [
              "tag",
              true
            ],
            [
              "is-light is-text",
              true
            ],
            [
              "is-family-code",
              true
            ],
            [
              "is-clickable",
              Stdlib_Option.isSome(onClick)
            ],
            [
              "is-hidden",
              !showKey && Stdlib_Option.isSome(name)
            ]
          ]),
          href: href,
          onClick: onClick
        }),
        copyableKey ? JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
              name: "copy"
            }),
            className: LumiReact.classList([
              [
                "tag",
                true
              ],
              [
                "is-light is-text",
                !keyCopied
              ],
              [
                "is-success",
                keyCopied
              ]
            ]),
            style: {
              cursor: "copy"
            },
            onClick: copyKey
          }) : null
      ],
      className: "tags has-addons",
      title: Params.tag
    });
  };
  let DocInfo = {
    make: Schema$Make$DocInfo
  };
  return {
    documentName: documentName,
    tag: Params.tag,
    jsonCodec: Params.jsonCodec,
    icon: Params.icon,
    readOnly: Params.readOnly,
    makeDocInfo: makeDocInfo,
    CmpKey: CmpKey,
    $$Set: $$Set,
    $$Map: $$Map,
    DocInfo: DocInfo
  };
}

export {
  Make,
}
/* react Not a pure module */
